module.exports = __webpack_public_path__ + "static/advanced-trust-pilot-3f0bcf4e04ee2542a7de9f3b83489457.png";